import { useEffect, useRef } from "react";

export const useSelectValue = (condition: boolean) => {
  const ref = useRef<any>(null);

  useEffect(() => {
    if (condition) {
      const { current } = ref;

      if (current) {
        current.inputElement.focus();
        current.inputElement.select();
      }
    }
  }, [ref, condition]);

  return { ref };
};
